module.exports = __webpack_public_path__ + "static/bai_fct1-5390afc3087489e21969ae1188e0771e.jpg";